module.exports = __webpack_public_path__ + "static/fee02-9646ec6edb70186d75408b8c3ba3ea7c.png";